import { get, post } from '../index'
import { startEnrollDetail, EnrollSalesInvitationDetail } from '@/interface'

export async function getCourseDetail (invitationCode: string) {
  return await get('/user/invitation/getDetail', { invitationCode })
}

export async function startEnroll (data: startEnrollDetail) {
  return await post('/user/invitation/use', data)
}

export async function enrollSalesInvitation (data: EnrollSalesInvitationDetail) {
  return await post('/user/invitation/sales/use', data)
}

export async function getCertificateDetailByInvite (code: string) {
  return await get('/user/invitation/certification/release/info', { code })
}

export async function enrollPracticalExamByInvite (data: {
  practicalExamId: number
  code: string
  allergies: string
  dietaryRequirements: string
}) {
  return await post('/user/practicalExamApprove/enrollByInvitationCode', data)
}
